import React from 'react';

import { ChannelGroup } from '../../../../../shared/types';

import { Box, Chip } from '@mui/material';
export const ALL_GROUPS = 'ALL_GROUPS';

interface OrderedGroupChipsProps {
    groups: ChannelGroup[];
    selectedGroupId: string;
    onSelectGroup: (groupId: string) => void;
}

const OrderedGroupChips: React.FC<OrderedGroupChipsProps> = ({
    groups,
    selectedGroupId,
    onSelectGroup,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                mt: 2,
            }}
        >
            <Chip
                label="All"
                variant={selectedGroupId === ALL_GROUPS ? 'solid' : 'outlined'}
                color={selectedGroupId === ALL_GROUPS ? 'primary' : 'default'}
                onClick={() => onSelectGroup(ALL_GROUPS)}
            />
            {groups.map((group) => (
                <Chip
                    key={group._id}
                    label={group.name}
                    variant={
                        selectedGroupId === group._id ? 'solid' : 'outlined'
                    }
                    color={
                        selectedGroupId === group._id ? 'primary' : 'default'
                    }
                    onClick={() => onSelectGroup(group._id)}
                />
            ))}
        </Box>
    );
};

export default OrderedGroupChips;
